<template>
  <div class="container-custom">
    <!-- BreadScrumbs -->
    <BreadScrumbs
      :links="[
        {
          name: 'Investor Relations',
          to: {
            name: 'IR'
          },
        },
         {
          name: 'Detail Page',
          to: {
            name: 'IRFinacialInformationDetailPage'
          },
        }
      ]"
    ></BreadScrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Detail Page</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="createHandler">
        <v-icon class="mr-2" color="white">add</v-icon>
        <span>新增</span>
      </button>
    </div>
    <!--  -->
    <DetailPageTable class="mb-5"></DetailPageTable>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BreadScrumbs from '@/components/Breadscrumbs.vue';
import DetailPageTable from '@/views/I_IR/c/DetailPageTable.vue';

export default {
  components: {
    BreadScrumbs,
    DetailPageTable,
  },
  created() {
    this.clear();
    this.getFinancials();
  },
  methods: {
    ...mapActions('financial', {
      getFinancials: 'find',
      clear: 'clear',
    }),
    createHandler() {
      this.$router.push(
        '/investor-relations/detail-page/create-financial-information',
      );
    },
    toEditDetailPageTitle() {
      this.$router.push('/investor-relations/detail-page/page-title-edit');
    },
  },
};
</script>

<style></style>
